import React, { ChangeEventHandler, forwardRef, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowQuestionnaireFieldItem } from 'src/interfaces/reservation_flow';
import { useDataAttributeProps } from 'src/hooks/useDataAttributeProps';
import { RSTextField } from 'src/reservation-page/forms/RSTextField';

export interface QuestionnaireInputTextFieldProps {
  [key: `data-${string}`]: string | undefined;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  item: ReservationFlowQuestionnaireFieldItem;
  isError?: boolean;
}

export const QuestionnaireInputTextField = forwardRef<
  HTMLInputElement,
  QuestionnaireInputTextFieldProps
>((props, ref) => {
  const dataAttributes = useDataAttributeProps(props);
  const { value, onChange, onBlur, item, isError } = props;

  const intl = useIntl();

  const onInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div>
      <div className="mb-1.5">
        <div className="rs-font text-16 text-gray-1000 pc:text-15 whitespace-pre-wrap font-normal">
          {item.label}
        </div>
      </div>
      <div>
        <RSTextField
          {...dataAttributes}
          ref={ref}
          labelText={intl.formatMessage({
            defaultMessage: '回答内容',
            id: 'WvUHNT',
            description:
              'src/templates/merchants/resources/book/components/questionnaire/QuestionnaireInputTextField/index.tsx',
          })}
          isBlock
          isError={isError}
          required={item.is_required}
          value={typeof value !== 'undefined' ? value : ''}
          onChange={onInputChange}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
});

QuestionnaireInputTextField.displayName = 'QuestionnaireInputTextField';
